
import { createAction, props } from "@ngrx/store";
import { Journey } from "../shared/domain/journey";

export const saveJourneyData = createAction(
  "[Journey] Save Data",
  props<{ journey: Journey }>()
);